import React, { useState } from 'react'
import { img } from '../assets/assets'

const Audit = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)

    return (
        <>
            <div className="overflow-hidden">
                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>
                            {/* -- ================== -- */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li onClick={() => window.open()}>
                                        <a
                                            className="color_black"
                                            href={img.whitepaper}
                                            // target="_blank"
                                            // rel="noreferrer"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            {/* -- ================= -- */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>
                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href={img.whitepaper}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>

                <div className="container">
                    <div className="section mt-100">
                        <div className="section__head">
                            <h2 className="section__title mb-20">
                                {' '}
                                All Audits
                            </h2>
                            <div className="row justify-content-between align-items-center"></div>
                        </div>
                        <div className="row mb-30_reset">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="card__item four">
                                    <div className="card_body space-y-10">
                                        <div className="card_head rugfree">
                                            <img
                                                src={img.rugfreecoin}
                                                alt="Rugfreecoins"
                                            />
                                        </div>
                                        {/* <!-- =============== --> */}
                                        <h6 className="card_title">
                                            Rugfreecoins
                                        </h6>
                                        <div className="card_footer d-block space-y-10">
                                            <div className="card_footer justify-content-between">
                                                <div className="creators">
                                                    <p className="txt_sm">
                                                        {' '}
                                                        Applied{' '}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="hr"></div>
                                            <div
                                                className="d-flex align-items-center space-x-10
			        						justify-content-between"
                                            >
                                                <a
                                                    className="btn btn-sm btn-primary"
                                                    href="/dashboard"
                                                >
                                                    View Document
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="card__item four">
                                    <div className="card_body space-y-10">
                                        <div className="card_head rugfree">
                                            <img src={img.techrate} alt="" />
                                        </div>
                                        <h6 className="card_title">Techrate</h6>
                                        <div className="card_footer d-block space-y-10">
                                            <div className="card_footer justify-content-between">
                                                <div className="creators">
                                                    <p className="txt_sm">
                                                        {' '}
                                                        Applied{' '}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="hr"></div>
                                            <div
                                                className="d-flex align-items-center space-x-10
			        						justify-content-between"
                                            >
                                                <a
                                                    className="btn btn-sm btn-primary"
                                                    href="/dashboard"
                                                >
                                                    View Document
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="card__item four">
                                    <div className="card_body space-y-10">
                                        <div className="card_head rugfree">
                                            <img src={img.certik} alt="" />
                                        </div>
                                        <h6 className="card_title">Certik</h6>
                                        <div className="card_footer d-block space-y-10">
                                            <div className="card_footer justify-content-between">
                                                <div className="creators">
                                                    <p className="txt_sm">
                                                        Coming Soon
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="hr"></div>
                                            <div
                                                className="d-flex align-items-center space-x-10
			        						justify-content-between"
                                            >
                                                <a
                                                    className="btn btn-sm btn-primary"
                                                    href="/dashboard"
                                                >
                                                    View Document
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="index.html">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>
                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            {' '}
                                            <a href="https://www.instagram.com/seduce_token_official/?utm_medium=copy_link">
                                                {' '}
                                                <i className="ri-instagram-line"></i>{' '}
                                            </a>
                                        </li>
                                        <li>
                                            {' '}
                                            <a href="https://twitter.com/seducetokenbsc">
                                                {' '}
                                                <i className="ri-twitter-line"></i>{' '}
                                            </a>
                                        </li>
                                        <li>
                                            {' '}
                                            <a href="https://discord.gg/kQYzKjEW5B">
                                                {' '}
                                                <i className="ri-discord-line"></i>{' '}
                                            </a>
                                        </li>
                                        <li>
                                            {' '}
                                            <a href="https://t.me/seducetokenofficial">
                                                {' '}
                                                <i className="ri-telegram-line"></i>{' '}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        {' '}
                                        <a href="index.html"> Home </a>
                                    </li>
                                    <li>
                                        {' '}
                                        <a href="about.html"> About us</a>{' '}
                                    </li>
                                    <li>
                                        {' '}
                                        <a href="team.html"> Our Team</a>
                                    </li>
                                    <li>
                                        {' '}
                                        <a
                                            className="color_black"
                                            href="roadmap.html"
                                        >
                                            {' '}
                                            Roadmap{' '}
                                        </a>{' '}
                                    </li>
                                    <li>
                                        {' '}
                                        <a href="ambassador.html">
                                            {' '}
                                            Ambassadors{' '}
                                        </a>{' '}
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        {' '}
                                        <a href="contact.html"> Contact Us </a>
                                    </li>
                                    <li>
                                        {' '}
                                        <a href="/dashboard" target="_blank">
                                            {' '}
                                            Buy Token{' '}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        {' '}
                                        <a
                                            href="assets/img/docs/whitepaper.pdf"
                                            target="_blank"
                                        >
                                            {' '}
                                            Whitepaper{' '}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by{' '}
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default Audit
